import {NgModule} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {AuthenticationGuard} from './core/authentication/authentication.guard';
import {PublicComponent} from './layouts/public/public.component';
import {SecureComponent} from './layouts/secure/secure.component';
import {PUBLIC_ROUTES} from './layouts/public/public.routes';
import {SECURE_ROUTES} from './layouts/secure/secure.routes';
import { GeoBlockedComponent } from './shared/geo-blocked/geo-blocked.component';

// Component definitions
// Idea from : https://stackoverflow.com/questions/40508557/multiple-layout-for-different-pages-in-angular-2
const APP_ROUTES: Routes = [
  {path: '', component: PublicComponent, data: {title: 'Public Views'}, children: PUBLIC_ROUTES},
  {path: '', component: SecureComponent, canActivate: [AuthenticationGuard], data: {title: 'Secure Views'}, children: SECURE_ROUTES},
  {path: 'geo-blocked', component: GeoBlockedComponent}
  // {path: '', component: SecureComponent, canActivate: [AuthenticationGuard], data: {title: 'Secure Views'}, children: SECURE_ROUTES},
];

@NgModule({
  imports: [RouterModule.forRoot(APP_ROUTES)],
  exports: [RouterModule]
})
export class AppRoutingModule {
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/sportstv/client/sportstv-web-client-prod/src/app/app-routing.module.ts